import axios from 'axios'
import { errorHandler } from '../exports/error_management'


const state = {
    dashboardData: {},
    analyticsData: {},
    dashboardDataLoading: false,
    analyticsDataLoading: false,
    analyticsOrdersData: []
}

const getters = {
    officers(state) {
        return state.analyticsData.officers
    },
    orders(state) {
        return state.analyticsData.orders
        // return state.analyticsData.orders
    },
    orderTypes(state) {
        return state.analyticsData.orderTypes
    },
    roles(state) {
        return state.analyticsData.roles
    },
    assets(state) {
        return state.analyticsData.assets
    },
    assetTypes(state) {
        return state.analyticsData.assetTypes
    },

    orders_cnt(state) {
        return state.dashboardData.orders
    },

    crm_cnt(state) {
        return state.dashboardData.crm
    },

    asset_cnt(state) {
        return state.dashboardData.asset
    },

    customers_cnt(state) {
        return state.dashboardData.customers
    },

}

const mutations = {
    set_dashboard(state, dashboardData) {
        state.dashboardData = dashboardData || {}
    },

    set_analytics(state, analyticsData) {
        state.analyticsData = analyticsData || {}
    },
    set_order_analytics(state, analyticsOrdersData) {
        state.analyticsOrdersData = analyticsOrdersData || []
    },
    set_dashboard_loading(state, x) {
        state.dashboardDataLoading = !!x
    },

    set_analytics_loading(state, x) {
        state.analyticsDataLoading = !!x
    },
}

const actions = {
    async getDashboardData({ commit }) {
        try {
            commit('set_dashboard_loading', true)
            const resp = await axios.get(`js-report/dashboard`)
            commit('set_dashboard', resp.data.success.data)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('set_dashboard_loading', false)
        }
    },
    async getAnalytics({ commit }) {
        try {
            commit('set_analytics_loading', true)
            const [assetResp, orderResp] = await Promise.all([
                axios.get(`js-report/orders-analytics`),
                axios.get(`js-report/assets-analytics`),
            ])
            const data = { ...assetResp.data.success.data, ...orderResp.data.success.data }
            commit('set_analytics', data)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('set_analytics_loading', false)
        }
    },

    async getOrderAnalytics({ commit }) {
        try {
            commit('set_analytics_loading', true)
            const [orderResp] = await Promise.all([
                axios.get(`js-report/orders-analytics`),
            ])
            const data = { ...orderResp.data.success.data }
            commit('set_order_analytics', data)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('set_analytics_loading', false)
        }
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
